export default __webpack_public_path__ + "static/media/hht1_ep14_timeline_q05_a.c98134ab.png";